import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';
import cardCss from './card.css';

type Props = { children: React.ReactNode; className?: string; 'data-testid'?: string };

type CardTitleProps = Props & TextProps<'h3'>;

const CardBase = forwardRef<HTMLElement, Props>(({ children, className, 'data-testid': dataTestId }, cardRef) => (
  <article className={clsx(cardCss.cardBase, className)} ref={cardRef} data-testid={dataTestId}>
    {children}
  </article>
));
const CardHeader = ({ children, className }: Props) => (
  <div className={clsx(cardCss.cardHeader, className)}>{children}</div>
);
const CardTitle = ({ children, ...args }: CardTitleProps) => (
  <Text variant="section-title" {...args}>
    {children}
  </Text>
);
const CardFooter = ({ children, className }: Props) => (
  <div className={clsx(cardCss.cardFooter, className)}>{children}</div>
);
export const Card = Object.assign(CardBase, { Header: CardHeader, Title: CardTitle, Footer: CardFooter });
